// Import hand sanitizer images
import group99125 from '../../assets/99125_group.webp';
import whtBlucap9042 from '../../assets/9042_WHTBLUCAP_White_Label.webp';
import hs31 from '../../assets/HS31.webp';
import zscpBk from '../../assets/ZSCP-BK.webp';

export const handSanitizerProducts = [
    {
        image: group99125,
        alt: 'Hand Sanitizer Gel'
    },
    {
        image: whtBlucap9042,
        alt: 'Hand Sanitizer Wipes'
    },
    {
        image: hs31,
        alt: 'Portable Hand Sanitizer'
    },
    {
        image: zscpBk,
        alt: 'Hand Sanitizer Spray Pens'
    }
]; 